import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Chart } from 'react-google-charts';
import { IHistory } from '../../interfaces';
import { parseJwt } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { Loader } from '../reusableComponents/Loader/Loader';
import { getUserData } from '../../services/utilityServices';
import { getUserGraphData, getYearGraphData, getUsersByCategoryAndMonth, getCategoryWiseData } from '../../services/dashboardService';
import './dashboard.scss';
import { Select } from '../reusableComponents/FormComponents/Select';
import { YEAR_OPTIONS } from '../../constants/generals';
import CategoryStackedBar from '../reusableComponents/StackedBarChart/index';
import PopupModal from '../reusableComponents/StackedBarChart/PopupModal';
import { IMenuItems } from '../../interfaces';

export interface IDashboardGraphProps {
    instances: any;
    history: IHistory;
    userUID: string;
}

export interface IDashboardState {
    userGraph: Array<any>;
    yearGraph: Array<any>;
    isLoading: boolean;
    yearForYearGraph: string;
    categoryData: any[];
    selectedCategory: string;
    stackedBarData: any[];
    isPopupOpen: boolean;
    popupData: any;
    popupTitle: string;
    users: any[];
}

export class DashboardComponentImpl extends React.Component<IDashboardGraphProps, IDashboardState> {

    constructor(props: IDashboardGraphProps) {
        super(props);
        this.state = {
            isLoading: true,
            userGraph: [['', 'Training Completed', 'Training Pending', 'Overdue'],
            ['', 0, 0, 0]],
            yearGraph: [['', 'Trg Assigned Todate', 'Trg Completed Todate', 'Users', 'Modules'], ['', 0, 0]],
            yearForYearGraph: new Date().getFullYear().toString(),
            categoryData: [],
            selectedCategory: 'All',
            stackedBarData: [],
            isPopupOpen: false,
            popupData: null,
            popupTitle: '',
            users: []
        };
    }

    public promise = async () => {
        //  User Graph Data
        await getUserGraphData().then(res => {
            this.setState({ isLoading: false });
            if (res.data.length) {
                this.setState({
                    userGraph: [['', 'Training Completed', 'Training Pending', 'Overdue']].concat(res.data)
                });
            }
        }).catch(err => {
            console.error('Error loading user graph:', err);
        });

        await this.loadYearGraphData(this.state.yearForYearGraph);

        await this.loadCategoryData('All');  //  'All' pass
    }

    public loadCategoryData = async (selectedCategory?: string) => {
        try {
            this.setState({ isLoading: true });

            const category = selectedCategory || this.state.selectedCategory || 'All';
            const year = this.state.yearForYearGraph;  //  Year add 

            const response = await getCategoryWiseData(year, 'all');  //  year pass 


            if (response && response.categories && response.categories.length > 0) {
                const categories = response.categories;

                //  'All' category  FILTER 
                const filteredCategories = categories.filter((cat: any) => cat.category !== 'All');

                //  CATEGORIES STORE 
                this.setState({
                    categoryData: filteredCategories,
                    isLoading: false
                });

                if (selectedCategory && selectedCategory !== 'All') {
                    this.updateStackedBarData(category, categories);
                }

            } else {
                this.setState({ isLoading: false });
            }
        } catch (error) {
            console.error('Error loading category data:', error);
            this.setState({ isLoading: false });
        }
    }

    public updateStackedBarData = (category: string, categories: any[]) => {

        let chartData: any[] = [];

        const normalizeMonth = (month: string) => {
            const monthMap: Record<string, string> = {
                'January': 'Jan', 'Jan': 'Jan',
                'February': 'Feb', 'Feb': 'Feb',
                'March': 'Mar', 'Mar': 'Mar',
                'April': 'Apr', 'Apr': 'Apr',
                'May': 'May',
                'June': 'Jun', 'Jun': 'Jun',
                'July': 'Jul', 'Jul': 'Jul',
                'August': 'Aug', 'Aug': 'Aug',
                'September': 'Sep', 'Sep': 'Sep',
                'October': 'Oct', 'Oct': 'Oct',
                'November': 'Nov', 'Nov': 'Nov',
                'December': 'Dec', 'Dec': 'Dec'
            };
            return monthMap[month] || month;
        };

        let categoryData = null;
        if (category === 'All') {
            categoryData = categories.find(cat => cat.category === 'All');
        } else {
            categoryData = categories.find(cat => cat.category === category);
        }

        if (categoryData && categoryData.data && categoryData.data.length > 0) {

            chartData = categoryData.data.map((item: any) => ({
                month: normalizeMonth(item.month),
                assigned: item.assigned || 0,
                completed: item.completed || 0,
                users: item.users || 0,      //  Category specific users
                modules: item.modules || 0   //  Category specific modules
            }));

            const filteredData = chartData.filter(item =>
                item.assigned > 0 || item.completed > 0 || item.users > 0 || item.modules > 0
            );

            this.setState({ stackedBarData: filteredData });
            return;
        }

        this.setState({ stackedBarData: [] });
    }


    public loadYearGraphData = async (value?: any, category?: string) => {
        if (value) {
            this.setState({ yearForYearGraph: value });
        }

        const year = value || this.state.yearForYearGraph;
        const selectedCategory = category || this.state.selectedCategory || 'All';

        this.setState({
            yearGraph: [['', 'Training Assigned Todate', 'Training Completed Todate', 'Users', 'Modules'], ['', 0, 0, 0, 0]],
            stackedBarData: [],
            isLoading: true
        });

        try {
            //  Category parameter pass 
            const categoryParam = selectedCategory === 'All' ? 'all' : selectedCategory;
            const res = await getYearGraphData(year, categoryParam);
            this.setState({ isLoading: false });

            const data = res.data || [];

            const monthMap: Record<string, any> = {};
            data.forEach((row: any) => {
                monthMap[row[0]] = row;
            });

            const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            const finalData = allMonths.map(month => {
                const row = monthMap[month];
                if (row) {
                    return [
                        month,
                        Number(row[1]) || 0,
                        Number(row[2]) || 0,
                        Number(row[3]) || 0,
                        Number(row[4]) || 0
                    ];
                }
                return [month, 0, 0, 0, 0];
            });

            this.setState({
                yearGraph: [
                    ['', 'Training Assigned Todate', 'Training Completed Todate', 'Users', 'Modules'],
                    ...finalData
                ],
                stackedBarData: finalData.map((row: any) => ({
                    month: row[0],
                    assigned: row[1] || 0,
                    completed: row[2] || 0,
                    users: row[3] || 0,
                    modules: row[4] || 0
                })),
                isLoading: false
            });

        } catch (error) {
            console.error('Error loading year graph data:', error);
            this.setState({ isLoading: false });
        }
    }

    public openPopup = (data: any, title: string) => {
        this.setState({
            isPopupOpen: true,
            popupData: data,
            popupTitle: title
        });
    }

    public closePopup = () => {
        this.setState({
            isPopupOpen: false,
            popupData: null,
            popupTitle: ''
        });
    }


    public handleBarClick = async (payload: any) => {
        try {
            if (!payload) {
                return;
            }

            const month = payload.month || 'Unknown';
            const year = this.state.yearForYearGraph;  

            //  Category ID mapping
            const categoryMap = {
                'EnviroConnect': '1',
                'SafeConnect': '2',
                'PermitConnect': '3'
            };

            const categoryName = this.state.selectedCategory || 'All';
            const categoryId = categoryMap[categoryName] || categoryName;

            //  Popup open with loading
            this.setState({
                isPopupOpen: true,
                popupData: {
                    month: month,
                    year: year,
                    category: categoryName,
                    users: [],
                    isLoading: true,
                    totalAssigned: payload.assigned || 0,
                    totalCompleted: payload.completed || 0,
                    totalUsers: payload.users || 0,
                    totalModules: payload.modules || 0
                },
                popupTitle: `${month} ${year} - ${categoryName} Training Statistics`  
            });

            //  Category ID + Month + Year pass 
            const response = await getUsersByCategoryAndMonth(categoryId, month, year);  

            this.setState({
                popupData: {
                    ...this.state.popupData,
                    users: response.users || [],
                    isLoading: false
                }
            });

        } catch (error) {
            console.error('Error fetching user details:', error);
            this.setState({
                popupData: {
                    ...this.state.popupData,
                    isLoading: false,
                    users: []
                }
            });
        }
    }

    public renderUserModuleList = () => {
        const categoryOptions: IMenuItems[] = [
            { label: 'All', value: 'All' },
            ...this.state.categoryData.map((cat: any) => ({
                label: cat.category,
                value: cat.category
            }))
        ];

        return (
            <div className="graphs-container">
                <div className="graph">
                    <div className="user-graph-title">User Statistics</div>
                    <Chart className="user-graph"
                        width={'90%'}
                        height={'100%'}
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        data={this.state.userGraph}
                        options={{
                            chartArea: { width: '60%' },
                            backgroundColor: '#cee3f5',
                            legend: { position: 'bottom', alignment: 'center' },
                            colors: ['#168f08', '#eff21f', '#ef0720'],
                            isStacked: true,
                            hAxis: {
                                title: '',
                                minValue: 0, format: '0'
                            },
                            vAxis: {
                                title: '', format: '0'
                            },
                        }}
                    />
                </div>
                <br /><br />

                <div className="section-header" style={{ textAlign: 'center', marginBottom: '15px', paddingBottom: '10px' }}>
                    <h3 className="section-title">
                        Training Statistics - {this.state.selectedCategory}
                    </h3>
                </div>

                {/*  YEAR + CATEGORY DROPDOWN - SIDE BY SIDE  */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    gap: '30px',
                    flexWrap: 'wrap',
                    marginBottom: '20px'
                }}>
                    {/* Year Dropdown */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ minWidth: '120px' }}>
                            <Select
                                menuItems={YEAR_OPTIONS}
                                multiple={false}
                                color={'white'}
                                hintText=""
                                onChange={async (e, value) => {
                                    const category = this.state.selectedCategory || 'All';
                                    await this.loadYearGraphData(value, category);
                                }}
                                value={this.state.yearForYearGraph}
                            />
                        </div>
                    </div>

                    {/* Category Dropdown */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ minWidth: '150px' }}>
                            <Select
                                menuItems={categoryOptions}
                                multiple={false}
                                color={'white'}
                                hintText="Select Category"
                                onChange={async (e, value) => {
                                    this.setState({ selectedCategory: value });
                                    const year = this.state.yearForYearGraph;
                                    await this.loadYearGraphData(year, value);
                                }}
                                value={this.state.selectedCategory}
                            />
                        </div>
                    </div>
                </div>

                {this.state.isLoading && <Loader type="submission" />}

                {/* Category Stacked Bar Chart */}
                <div className="category-chart-section">
                    <div className="category-chart-container">
                        <CategoryStackedBar
                            data={this.state.stackedBarData}
                            onBarClick={this.handleBarClick}
                        />
                    </div>
                    <PopupModal
                        isOpen={this.state.isPopupOpen}
                        data={this.state.popupData}
                        title={this.state.popupTitle}
                        onClose={this.closePopup}
                    />
                </div>
            </div>
        );
    }
    
    renderSideButtons = () => {
    const handlePrint = () => {
        window.print();
    };

    return (
        <div style={{ 
            display: "flex", 
            alignItems: "center",
            gap: "12px",
            marginTop: "-10px",        
            marginRight: "15px"
        }}>
            <div 
                onClick={handlePrint}
                style={{ 
                    cursor: "pointer", 
                    fontSize: "41px",
                    color: "#ffffff",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "background 0.2s"
                }}
            >
                <i className="fa fa-print" aria-hidden="true" />
            </div>
        </div>
    );
};

    render() {
        return <BasePage sideButton={this.renderSideButtons()} title="Dashboard" icon="chart-pie">
            <Async
                identifier="Dashboard"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderUserModuleList()}
                error={<Loader type="async" />}
            />
        </BasePage>;
    }

}

export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    return {
        userUID
    };
}

export const DashboardGraphPage =
    withRouter(connect<{}, {}, IDashboardGraphProps>(mapStateToProps)(DashboardComponentImpl) as any);





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/dashboard.tsx